export enum AppImageSourceTab {
  /** 应用仓库（available-container-images） */
  Repo = 'repo',
  /** 应用广场（ophub artifacts） */
  Plaza = 'plaza',
}
